"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var rx = require("rxjs");
var keautils_1 = require("keautils");
var rxToReact_1 = require("./rxToReact");
var reselect_1 = require("reselect");
;
var createShallowSelector = reselect_1.createSelectorCreator(reselect_1.defaultMemoize, keautils_1.shallowEquals);
/**
 * Dibuja una función render que toma un observable de props y devuelve un observable de elementos.
 * El observable de props se formará a partir de los campos de prop "prop"
 */
var PropsToRx = /** @class */ (function (_super) {
    __extends(PropsToRx, _super);
    function PropsToRx(props) {
        var _this = _super.call(this, props) || this;
        _this.onNextProps = function (x) {
            _this.propsObs.next(x);
        };
        _this.renderFunc = function (x) { return x.render; };
        _this.jsxObs = keautils_1.createSelector(_this.renderFunc, function (render) {
            return render(_this.propsObs);
        });
        _this.compRx = keautils_1.createSelector(_this.jsxObs, function (jsxObs) { return React.createElement(rxToReact_1.RxToReact, { value: jsxObs }); });
        _this.compProps = function (x) { return x.props; };
        _this.syncRx = function (x) { return x.syncRender; };
        _this.compSync = createShallowSelector(_this.compProps, _this.syncRx, function (props, SyncRx) {
            return (SyncRx != null) ? React.createElement(SyncRx, __assign({}, props)) : undefined;
        });
        //Si el compSync esta definido, entonces hacemos un 'passThru', note que devolvemos el RxToReact con el value asignado en lugar de devolver directamente al compSync
        //Esto es para mantener la estructura del arbol de react y no perder el state del compSync
        _this.comp = keautils_1.createSelector(_this.compSync, _this.compRx, function (compSync, compRx) {
            return (compSync != null) ? React.createElement(rxToReact_1.RxToReact, { value: compSync }) : compRx;
        });
        _this.propsObs = new rx.BehaviorSubject(props.props);
        _this.state = {
            onNextProps: _this.onNextProps,
            lastProps: props.props
        };
        return _this;
    }
    PropsToRx.getDerivedStateFromProps = function (nextProps, prevState) {
        if (!keautils_1.shallowEquals(prevState.lastProps, nextProps.props)) {
            prevState.onNextProps(nextProps.props);
            return __assign({}, prevState, { lastProps: nextProps.props });
        }
        return null;
    };
    PropsToRx.prototype.render = function () {
        return this.comp(this.props);
    };
    return PropsToRx;
}(React.PureComponent));
exports.PropsToRx = PropsToRx;
//# sourceMappingURL=propsToRx.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-rxk/dist/propsToRx.js
// module id = 710
// module chunks = 0